import React from 'react'
import { useFlag } from '@sketch/modules-common'
import { Inbox } from '@sketch/user'

import { UpdatesOld, UpdatesViewProps } from './UpdatesOld'

export type { UpdatesRoutesProps, UpdatesViewProps } from './UpdatesOld'

export const Updates: React.FCC<UpdatesViewProps> = props => {
  const isBetterNotificationsEnabled = useFlag('better-notifications')

  if (isBetterNotificationsEnabled) {
    return <Inbox {...props} />
  }

  return <UpdatesOld {...props} />
}
